import { useState, type CSSProperties } from "react";

/* fills the box the kit's hint card or notification row gives it */
const FILL: CSSProperties = { display: "block", width: "100%", height: "100%", objectFit: "contain" };

/**
 * An app's logo from the App Directory (lib/appDirectory `useAppLogo`). No logo — not known yet,
 * none set, or a picture that failed to load — is an empty box of the same size, never a letter
 * or a stand-in mark (owner rules, 2026-10-20). Handed to the kit as the `appIcon` answer, so the
 * kit's own letter tile never shows.
 */
export function AppDirectoryLogo({ src }: { src: string | null }) {
  const [failed, setFailed] = useState<string | null>(null);
  if (!src || failed === src) return <span style={FILL} aria-hidden="true" />;
  return <img src={src} alt="" draggable={false} style={FILL} onError={() => setFailed(src)} />;
}
